module.exports = __webpack_public_path__ + "static/media/cigarette-healthy-life-no-svgrepo-com.60a6882c.svg";